<div class="content-wrapper" *blockUI="'section-block'">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <div class="card">
            <div class="content-detached">
                <div class="content-body">
                    <div class="blog-detail-wrapper">
                        <div class="row">
                            <div class="col-12">
                                <div class="card-body">
                                    <div class="row">

                                        <div class="col-xl-4 col-md-6 col-xs-12 col-sm-12 col-12 d-flex">
                                            <div class="form-group col-xl-10">
                                                <label>Firma Seçiniz</label>
                                                <div class="form-group">
                                                    <ng-select [items]="companies" bindLabel="companyName"
                                                        bindValue="id" (change)="onCompanyChange($event.id)">
                                                    </ng-select>
                                                </div>
                                            </div>

                                            <div class="col-xl-1 col-md-1 col-xs-1 mt-2">
                                                <button type="button" class="btn btn-icon btn-outline-primary "
                                                    rippleEffect (click)="showCreateCompanyDialog()">
                                                    <span [data-feather]="'plus'"></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="col-xl-2 col-md-6 col-xs-12 col-sm-12 col-12"
                                            [ngClass]="{'disabled': persons?.length < 1}">

                                            <div class="form-group">
                                                <label>Firma Sorumlu Kişi</label>
                                                <div class="form-group">
                                                    <ng-select [bindValue]="'id'" (change)="onPersonChange($event)">
                                                        <ng-option *ngFor="let user of persons"
                                                            [value]="user.id">{{user.name + ' ' +
                                                            user.lastName}}</ng-option>
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-xl-4 col-md-6 col-xs-12 col-sm-12 col-12"
                                            [ngClass]="{'disabled': requestTask?.length < 1}">
                                            <div class="form-group">
                                                <label>Firma Ait Talepler</label>
                                                <div class="form-group">
                                                    <ng-select [items]="requestTask" bindLabel="title" bindValue="id"
                                                        (change)="onRequsetChange($event.id)">
                                                        <ng-template ng-option-tmp let-item="item" let-index="index"
                                                            let-search="searchTerm">
                                                            <div style="margin: 10px 0"
                                                                class="card shadow-none bg-transparent border-primary">
                                                                <div class="badge badge-pill" [ngClass]="{
                                                                  'badge-primary': item.status === 1,
                                                                  'badge-warning': item.status === 1,
                                                                  'badge-success': item.status === 2
                                                                }" style="color: white;">
                                                                    {{ item.status === 1 ? 'Devam Ediyor' : 'Tamamlandı'
                                                                    }}
                                                                </div>
                                                                <div class="card-body">

                                                                    <h5 class="card-title">{{ item.title }}</h5>
                                                                    <h6 class="card-subtitle mb-2 text-muted">{{
                                                                        item.description }}</h6>

                                                                    <div>
                                                                        <a class="card-link">{{item.startDate | date :
                                                                            'dd/MM/yyyy HH:mm'}}</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-xl-2 col-md-6 col-xs-12 col-sm-12 col-12">
                                            <label for="docNo">No</label>
                                            <input type="text" id="docNo" [(ngModel)]="docNo" class="form-control"
                                                placeholder="No" maxlength="16" />
                                        </div>


                                        <div class="col-xl-2 col-md-6 col-xs-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label>Oluşturma Tarihi</label>
                                                <div class="form-group">
                                                    <ng2-flatpickr [config]="dateTimeStartOptions"
                                                        name="dateTime"></ng2-flatpickr>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-xl-2 col-md-6 col-xs-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label>Bitiş Tarihi</label>
                                                <div class="form-group">
                                                    <ng2-flatpickr [config]="dateTimeEndOptions"
                                                        name="dateTime"></ng2-flatpickr>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-xl-4 col-md-6 col-xs-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label>Proje Seçiniz</label>
                                                <div class="form-group">
                                                    <ng-select [items]="project" bindLabel="name" bindValue="id"
                                                        (change)="onProjectChange($event)" (search)="onSearch($event)">
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-xl-4 col-md-6 col-xs-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label>Masraf Seçiniz</label>
                                                <div class="form-group">
                                                    <!-- <ng-select [bindValue]="'id'" (change)="onExpensesChange($event)">
                                                        <ng-option *ngFor="let expense of expenses"
                                                            [value]="expense.id">
                                                            {{expense.name}} - {{expense.typeName}}
                                                        </ng-option>
                                                    </ng-select> -->

                                                    <ng-select [searchFn]="searchFn" [items]="expenses" bindLabel="name"
                                                        bindValue="id" (change)=onExpensesChange($event)
                                                        groupBy="mainExpenseName" formControlName="expense">
                                                        <ng-template ng-optgroup-tmp let-item="item">
                                                            {{ item.mainExpenseName || 'Unnamed group' }}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-xl-12 col-md-6 col-xs-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label>Gizli Not</label>
                                                <div class="form-group">
                                                    <fieldset class="form-group">
                                                        <textarea class="form-control" id="basicTextarea" rows="1"
                                                            [(ngModel)]="privateDescription"
                                                            placeholder="Burada yazılanlar pdfde gözükmez."></textarea>
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="col-12" [ngClass]="{ 'ng-select-disabled': !company }">
                <div class="col-xl-6 col-md-8 col-xs-12 col-sm-12 col-12">
                    <div class="form-group d-flex align-items-center">
                        <!-- Label and ng-select wrapper -->
                        <div class="flex-grow-1">
                            <label>Ürün Seçin</label>
                            <ng-select #productSelect [items]="products" bindLabel="name" bindValue="id"
                                [clearable]="true" (change)="onProductChange($event)">
                            </ng-select>
                        </div>

                        <button type="button" class="btn btn-icon btn-outline-primary mt-2 ml-1" rippleEffect
                            (click)="showCreateProductDialog()">
                            <span [data-feather]="'plus'"></span>
                        </button>

                        <div ngbDropdown [placement]="'left'" class="btn-group dropup dropdown-icon-wrapper mt-1 ms-2">
                            <button ngbDropdownToggle type="button" class="btn btn-flat-primary dropdown-toggle-split"
                                rippleEffect>
                                <span [data-feather]="'more-vertical'" class="dropdown-icon"></span>
                            </button>
                            <div ngbDropdownMenu>
                                <span ngbDropdownItem (click)="isPrivateToogle()">
                                    Alış Detaylarını Görüntüle
                                </span>

                                <span ngbDropdownItem (click)="isPrivateDiscountToogle()">
                                    İndirim Detayını Görüntüle
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body table-responsive" *ngIf="!isMobile">
                    <table class="table">
                        <thead>
                            <tr>
                                <th style="width: 50%;">Ürün Adı</th>
                                <th>Miktar</th>
                                <th *ngIf="isPrivate" style="color: red;">Alış Fiyatı</th>
                                <th>Birim Fiyatı</th>
                                <th *ngIf="isDiscount">indirim</th>
                                <th *ngIf="isDiscount">Toplam</th>
                                <th>Net</th>
                                <th>KDV</th>
                                <th>V.D Toplam</th>
                                <th style="color: red;" *ngIf="isPrivate">Alış Toplam Fiyat</th>
                                <th style="color: red;" *ngIf="isPrivate">Alış Kdv</th>
                                <th style="color: red;" *ngIf="isPrivate">Alış Toplam</th>
                                <th>#</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let transaction of transactionList; let i = index">
                                <td style="width: 50%;">{{ transaction.product.name }}
                                    <br>
                                    <span class="description">{{ transaction.description }}</span>
                                </td>
                                <td>{{ transaction.count }}</td>
                                <td *ngIf="isPrivate">{{ formatNumber(transaction.product.purchasePrice) }}</td>
                                <td>{{ formatNumber(transaction.salePrice) }}</td>
                                <!-- Discount Amount Calculation -->
                                <td *ngIf="isDiscount">
                                    {{ transaction.discountRate === 0 ? '0.00' : formatNumber((transaction.salePrice *
                                    transaction.count) * transaction.discountRate / 100) }}
                                    (%{{transaction.discountRate}})
                                </td>
                                <td *ngIf="isDiscount">{{ formatNumber(transaction.salePrice * transaction.count) }}
                                </td>

                                <!-- Final Price After Discount Calculation -->
                                <td>
                                    {{ transaction.discountRate === 0 ? formatNumber(transaction.salePrice *
                                    transaction.count) : formatNumber((transaction.salePrice * transaction.count) -
                                    ((transaction.salePrice * transaction.count) * transaction.discountRate / 100)) }}
                                </td>

                                <!-- Tax Amount Calculation -->
                                <td>
                                    {{ transaction.discountRate === 0 ? formatNumber((transaction.salePrice *
                                    transaction.count) * transaction.saleTax / 100) :
                                    formatNumber(((transaction.salePrice * transaction.count) - ((transaction.salePrice
                                    * transaction.count) * transaction.discountRate / 100)) * transaction.saleTax / 100)
                                    }}
                                </td>

                                <!-- Total Including Tax Calculation -->
                                <td>
                                    {{ transaction.discountRate === 0 ? formatNumber((transaction.salePrice *
                                    transaction.count) + ((transaction.salePrice * transaction.count) *
                                    transaction.saleTax / 100)) : formatNumber(((transaction.salePrice *
                                    transaction.count) - ((transaction.salePrice * transaction.count) *
                                    transaction.discountRate / 100)) + (((transaction.salePrice * transaction.count) -
                                    ((transaction.salePrice * transaction.count) * transaction.discountRate / 100)) *
                                    transaction.saleTax / 100)) }}
                                </td>
                                <td *ngIf="isPrivate">{{transaction.product.purchasePrice * transaction.count}}</td>
                                <td *ngIf="isPrivate">{{ (((transaction.product.purchasePrice *
                                    transaction.product.purchaseTax) / 100) * transaction.count) | number:'1.1-2' }}
                                </td>
                                <td *ngIf="isPrivate">{{ ((transaction.product.purchasePrice * transaction.count) +
                                    (((transaction.product.purchasePrice * transaction.product.purchaseTax) / 100) *
                                    transaction.count)) | number:'1.1-2' }}</td>
                                <td>
                                    <div class="button-container">
                                        <button class="btn btn-icon btn-icon rounded-circle btn-flat-danger"
                                            (click)="deleteTransaction(i)">
                                            <i data-feather="x"></i>
                                        </button>
                                    </div>
                                </td>

                            </tr>
                            <tr *ngIf="totalAmount !== null">
                                <td colspan="9" style="text-align: right;">
                                    <div class="col-md-12 d-flex justify-content-end">
                                        <div class="invoice-total-wrapper">
                                            <div class="invoice-total-item">
                                                <p class="invoice-total-title">Toplam Miktar:</p>
                                                <p class="invoice-total-amount">{{ sumCount() }}</p>
                                            </div>
                                            <div class="invoice-total-item">
                                                <p class="invoice-total-title">Brüt Toplam:</p>
                                                <p class="invoice-total-amount">{{ sumGross() | number:'1.2-2' }}</p>
                                            </div>
                                            <div class="invoice-total-item">
                                                <p class="invoice-total-title">Toplam İndirim:</p>
                                                <p class="invoice-total-amount">{{ sumDiscount() | number:'1.2-2' }}</p>
                                            </div>
                                            <div class="invoice-total-item">
                                                <p class="invoice-total-title">Net Toplam:</p>
                                                <p class="invoice-total-amount">{{ sumNetTotal() | number:'1.2-2' }}</p>
                                            </div>
                                            <!-- <div *ngFor="let item of transactionVatTotal" class="invoice-total-item">
                                                <p class="invoice-total-title">Toplam Tutar ({{ item.currency }}):</p>
                                                <p class="invoice-total-amount">{{ item.totalAmount | number:'1.2-2' }}</p>
                                            </div> -->
                                            <div *ngFor="let item of transactionVatTotal" class="invoice-total-item">
                                                <p class="invoice-total-title">KDV Toplam %({{ item.saleTax }}):</p>
                                                <p class="invoice-total-amount">{{ item.totalVat | number:'1.2-2' }}</p>
                                            </div>
                                            <hr class="my-50" />
                                            <div class="invoice-total-item">
                                                <p class="invoice-total-title">Genel Toplam:</p>
                                                <p class="invoice-total-amount">{{ totalAmount | number:'1.2-2' }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <td colspan="12" style="text-align: right;" *ngIf="isPrivate">
                                    <div class="col-md-12 d-flex justify-content-end">
                                        <div class="invoice-total-wrapper">
                                            <div class="invoice-total-item">
                                                <p class="invoice-total-title">Alış KDV Hariç Toplam:</p>
                                                <p class="invoice-total-amount">{{ sumBuyingCount() | number:'1.1-2' }}
                                                </p>
                                            </div>
                                            <div class="invoice-total-item">
                                                <p class="invoice-total-title">KDV Hariç Kar:</p>
                                                <p class="invoice-total-amount">{{ sumExcludingVAT() | number:'1.1-2' }}
                                                </p>
                                            </div>
                                            <div *ngFor="let item of transactionPurchaseTaxTotal"
                                                class="invoice-total-item">
                                                <p class="invoice-total-title">Alış KDV Toplam (%{{ item.purchaseTax |
                                                    number:'1.1-2' }}):</p>
                                                <p class="invoice-total-amount">{{ item.totalPurchaseTax |
                                                    number:'1.1-2' }}</p>
                                            </div>
                                            <div class="invoice-total-item">
                                                <p class="invoice-total-title">KDV Farkı:</p>
                                                <p class="invoice-total-amount">{{ vatDifference | number:'1.1-2' }}</p>
                                            </div>
                                            <div class="invoice-total-item">
                                                <p class="invoice-total-title">KDV Dahil Kar:</p>
                                                <p class="invoice-total-amount">{{ total | number:'1.1-2' }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>

                            </tr>


                        </tbody>
                    </table>
                </div>

                <div *ngIf="isMobile">
                    <div class="card shadow-none bg-transparent border-primary mb-3 mt-1"
                        *ngFor="let transaction of transactionList; let i = index">
                        <div class="card-body">
                            <h4 class="card-title">{{ transaction.product.name }}</h4>
                            <p class="card-text">{{ transaction.description }}</p>

                            <div class="transaction-details">
                                <div class="detail-item">
                                    <strong>Adet:</strong> {{ transaction.count }}
                                </div>
                                <div class="detail-item">
                                    <strong>Satış Fiyatı:</strong> {{ transaction.salePrice | number:'1.2-2' }}
                                </div>
                                <div class="detail-item">
                                    <strong>KDV:</strong> {{ transaction.saleTax | number:'1.2-2' }}%
                                </div>
                                <div class="detail-item">
                                    <strong>İndirim:</strong> {{ transaction.discountRate | number:'1.2-2' }}%
                                </div>
                                <div class="detail-item">
                                    <strong>Toplam:</strong> {{ transaction.total | number:'1.2-2' }}
                                </div>
                            </div>
                            <button class="btn btn-danger btn-sm mt-2" (click)="deleteTransaction(i)">
                                <i data-feather="trash"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-md-12 d-flex justify-content-end">
                        <div class="invoice-total-wrapper">
                            <div class="invoice-total-item">
                                <p class="invoice-total-title">Toplam Miktar:</p>
                                <p class="invoice-total-amount">{{ sumCount() }}</p>
                            </div>
                            <div class="invoice-total-item">
                                <p class="invoice-total-title">Brüt Toplam:</p>
                                <p class="invoice-total-amount">{{ sumGross() | number:'1.2-2' }}</p>
                            </div>
                            <div class="invoice-total-item">
                                <p class="invoice-total-title">Toplam İndirim:</p>
                                <p class="invoice-total-amount">{{ sumDiscount() | number:'1.2-2' }}</p>
                            </div>
                            <div class="invoice-total-item">
                                <p class="invoice-total-title">Net Toplam:</p>
                                <p class="invoice-total-amount">{{ sumNetTotal() | number:'1.2-2' }}</p>
                            </div>
                            <!-- <div *ngFor="let item of transactionVatTotal" class="invoice-total-item">
                                <p class="invoice-total-title">Toplam Tutar ({{ item.currency }}):</p>
                                <p class="invoice-total-amount">{{ item.totalAmount | number:'1.2-2' }}</p>
                            </div> -->
                            <div *ngFor="let item of transactionVatTotal" class="invoice-total-item">
                                <p class="invoice-total-title">KDV Toplam %({{ item.saleTax }}):</p>
                                <p class="invoice-total-amount">{{ item.totalVat | number:'1.2-2' }}</p>
                            </div>
                            <hr class="my-50" />
                            <div class="invoice-total-item">
                                <p class="invoice-total-title">Genel Toplam:</p>
                                <p class="invoice-total-amount">{{ totalAmount | number:'1.2-2' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" d-flex justify-content-end">
            <button class="btn btn-success mt-1" (click)="createOffer()" [disabled]="transactionList.length < 1">
                Alış yap
            </button>
        </div>

    </div>
</div>